import React from "react";

/**
 * Modal for confirming deletion of items
 */
export function DeleteConfirmModal({ isOpen, onConfirm, onCancel, itemName, itemType = "item" }) {
  if (!isOpen) return null;

  return (
    <div className="modal modal-open">
      <div className="modal-box">
        <h3 className="font-bold text-lg">Confirm Delete</h3>
        <p className="py-4">
          Are you sure you want to remove {itemName || `this ${itemType}`}? This
          action cannot be undone.
        </p>
        <div className="modal-action">
          <button className="btn btn-ghost" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-error" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
      <div className="modal-backdrop bg-neutral/80" onClick={onCancel} />
    </div>
  );
} 